<div class="portfolios">
  <div class="row">
    <div class="col-md-12">
      <hr-portfolio-add
        [display]="displayModal"
        (onAdd)="onAddPortfolio($event)"
        (onClose)="onCloseModal($event)"
        (onUpdate)="onUpdateTable($event)"
      >
      </hr-portfolio-add>
    </div>
    <div class="col-md-9">
      <p-table [value]="portfolios" showGridlines>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width: 150px">
              {{ 'label.Portfolio' | translate }}
            </th>
            <th style="width: 20%">
              {{ 'label.AccountManager' | translate }}
            </th>
            <th>
              {{ 'label.Customers' | translate }}
            </th>
            <th style="width: 120px">
              {{ 'label.ActiveAnnouncements' | translate }}
            </th>
            <th>
              {{ 'label.ActiveDbProducts' | translate }}
            </th>
            <th>
              {{ 'label.ActiveCvBoxProduct' | translate }}
            </th>
            <th>
              {{ 'label.ActiveSlider' | translate }}
            </th>
            <th>
              {{ 'label.Comment' | translate }}
            </th>
            <th style="width: 150px">
              {{ 'label.ApprovedMatches' | translate }}
            </th>
            <th>
              {{ 'label.TotalDebt' | translate }}
            </th>
          </tr>
        </ng-template>

        <ng-template
          pTemplate="body"
          let-portfoliorecord
          let-expanded="expanded"
          let-columns="columns"
        >
          <tr>
            <td>
              <span
                ><a
                  [routerLink]="[
                    '/portfolios/view',
                    portfoliorecord.portfolio?.portfolioId
                  ]"
                  >{{ portfoliorecord.portfolio?.name }}</a
                ></span
              >
            </td>
            <td>
              <hr-portfolio-edit-account-manager
                [portfolio]="portfoliorecord.portfolio"
                (onEdit)="onEditAccountManagerClick($event)"
                (onUpdate)="onPortfolioAccountManagerUpdated($event)"
              >
              </hr-portfolio-edit-account-manager>
            </td>
            <td>
              <span>{{ portfoliorecord.customerTotal }}</span>
            </td>
            <td>
              <span>{{ portfoliorecord.activeAnnouncementTotal }}</span>
            </td>
            <td>
              <span>{{ portfoliorecord.activeDbProductTotal }}</span>
            </td>
            <td>
              <span>{{ portfoliorecord.activeCvBoxProductTotal }}</span>
            </td>
            <td>
              <span>{{ portfoliorecord.activeSliderTotal }}</span>
            </td>
            <td>
              <span>{{ portfoliorecord.portfolio?.comment }}</span>
            </td>
            <td>
              <span>{{ portfoliorecord.approvedMatches }}</span>
            </td>
            <td>
              <span>{{ portfoliorecord.totalDebt }}</span>
            </td>
          </tr>
        </ng-template>

        <!-- <p-column header="{{'label.Portfolio' | translate}}">
          <ng-template let-col let-portfoliorecord="rowData" pTemplate="body">
            <span><a [routerLink]="['/portfolios/view', portfoliorecord.portfolio?.portfolioId]">{{portfoliorecord.portfolio?.name}}</a></span>
          </ng-template>
        </p-column>
        <p-column header="{{'label.AccountManager' | translate}}" [style]="{'width':'17%'}" >
          <ng-template let-col let-portfoliorecord="rowData" pTemplate="body">
            <hr-portfolio-edit-account-manager [portfolio]="portfoliorecord.portfolio" (onEdit)="onEditAccountManagerClick($event)" (onUpdate)="onPortfolioAccountManagerUpdated($event)">
          </hr-portfolio-edit-account-manager>
          </ng-template>
        </p-column>
        <p-column header="{{'label.Customers' | translate}}">
          <ng-template let-col let-portfoliorecord="rowData" pTemplate="body">
            <span>{{portfoliorecord.customerTotal}}</span>
          </ng-template>
        </p-column>
        <p-column header="{{'label.ActiveAnnouncements' | translate}}">
          <ng-template let-col let-portfoliorecord="rowData" pTemplate="body">
            <span>{{portfoliorecord.activeAnnouncementTotal}}</span>
          </ng-template>
        </p-column>
        <p-column header="{{'label.ActiveDbProducts' | translate}}">
          <ng-template let-col let-portfoliorecord="rowData" pTemplate="body">
            <span>{{portfoliorecord.activeDbProductTotal}}</span>
          </ng-template>
        </p-column>

        <p-column header="{{'label.ActiveCvBoxProduct' | translate}}">
          <ng-template let-col let-portfoliorecord="rowData" pTemplate="body">
            <span>{{portfoliorecord.activeCvBoxProductTotal}}</span>
          </ng-template>
        </p-column>

        <p-column header="{{'label.ActiveSlider' | translate}}">
          <ng-template let-col let-portfoliorecord="rowData" pTemplate="body">
            <span>{{portfoliorecord.activeSliderTotal}}</span>
          </ng-template>
        </p-column>
        <p-column header="{{'label.Comment' | translate}}">
          <ng-template let-col let-portfoliorecord="rowData" pTemplate="body">
            <span>{{portfoliorecord.portfolio?.comment}}</span>
          </ng-template>
        </p-column>
        <p-column header="{{'label.ApprovedMatches' | translate}}">
          <ng-template let col let-portfoliorecord="rowData" pTemplate="body">
            <span>{{portfoliorecord.approvedMatches}}</span>
          </ng-template>
        </p-column>
        <p-column header="{{'label.TotalDebt' | translate}}">
          <ng-template let-col let-portfoliorecord="rowData" pTemplate="body">
            <span>{{portfoliorecord.totalDebt}}</span>
          </ng-template>
        </p-column> -->
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="10">
              {{ 'message.NoRecordsFound' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
